import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesApp from "./Rotas/RoutesApp";
import "./index.css";
import theme from "./theme";

//CHAKRA CSS BEGIN

import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { AuthContextProvider } from "./auth/AuthContext";
import NetworkStatus from "./config/netstatus/NetworkStatus";

//END

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <AuthContextProvider>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <NetworkStatus />
      <Router>
        <RoutesApp />
      </Router>
    </ChakraProvider>
  </AuthContextProvider>
);

export default RoutesApp;
